<!--首页-->
<template>
	<div>
		<div class="box" style="overflow:scroll !important"> 
 
 

			<div  >

				<van-collapse v-model="huiyiAcitiveCs" v-if="row.group_list.length>0">
					<van-collapse-item :title="group.name" v-for="(group,gindex) in row.group_list" :key="gindex" :name="gindex+1">
						<div class="train-box flex-between" style="flex-wrap: wrap;">
							<div class="train-items" v-for="(row,index) in group.list" @click="file(row)">
								<div class="train-items-top items-top1"
									 :style="'background-image: linear-gradient(to right, #'+row.color[0]+' , #'+row.color[1]+');'"
								>
									<div>
										<div class="train-items-top-city">{{row.location}}</div>
										<div class="train-items-top-time">{{row.date_str}}</div>
									</div>
									<!--<div class="train-sing-up-btn">报名</div>-->
								</div>
								<div class="train-items-title">{{row.name}}</div>
								<div class="flex-between"  >
									<div class="train-items-time">相关文件 &gt;</div> 
								</div> 
							</div>

						</div>
					</van-collapse-item>
				</van-collapse>
			</div>
			  


			<LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel" />
		</div>

	</div>
</template>
<style scoped>
	/* @import '../../assets/style/index.css'; */


	.row4{
		/*display: flex;*/
		/*align-items: center;*/
		/*justify-content: space-between;*/
		margin: 10px 10px;
		/*flex-wrap: wrap;*/
	}
	.row4 img{
		width: 100%;
		float: left;
		width: calc(25% - 10px);
		margin: 0 10px 10px 0;
	}
	.row4 img.current{
		box-shadow: 0px 0px 10px 0px rgba(119,175,255,1);
	}
	.more-box{
		width: 6.25rem;
		background: #fff;
		margin:20px auto;
		border-radius: 10px;
		overflow: hidden;
		padding: 20px;
	}
	.more-active{
		width: 100%;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}
	.solid1{background-image: linear-gradient( #1EB2FF , #2B7AFF);}
	.solid2{background-image: linear-gradient( #FFC934 , #FF9C00);}
	.solid3{background-image: linear-gradient( #FF7D6F , #FF433E);}
	.solid4{background-image: linear-gradient( #E77EFF , #8B5AFD);}
	.solid5{background-image: linear-gradient( #FFC934 , #FF9C00);}
	.solid6{background-image: linear-gradient( #1EB2FF , #2B7AFF);}
	.solid7{background-image: linear-gradient( #FF7D6F , #FF4540);}



	.more-items{width: 2.02rem;position: relative;display: flex;align-items: center;}
	.more-items img{width: 2.02rem;}
	.more-items span{font-size:14px;
		font-family:'PingFangSC-Regular,PingFang SC';
		font-weight:400;
		color:rgba(255,255,255,1);
		position: absolute;left: 7px;}

	.more-active .solid{width: 4px;height: 25px;border-radius: 4px;margin-right: 5px;}
	.more-active .more-title{color:#333;font-size:16px; height: 25px;line-height: 25px;}
	.more-active .more-right{color:#333;font-size:14px; height: 25px;line-height: 25px;}
	.more-active img{margin-left: 5px;width: 5.5px;height: 10px;}
	.main-solid{width:100%;height:1px;background-color:#f8f8f8;margin:10px 0}
	.flex-between{display:flex;justify-content: space-between;}
	.fontFamily{font-family:'PingFangSC-Regular,PingFang SC';}


	.train-items{width: 3.08rem; margin-bottom: 0.3rem}

	.items-top1{background-image: linear-gradient(to right, #01EA9B , #8DEC9D);}
	.items-top2{background-image: linear-gradient(to right, #2B7AFF , #1EB2FF);}

	.train-items-top{width: 3.08rem;height: 1.68rem;border-radius: 10px;
		display: flex;align-items: center;justify-content: space-around;}
	.train-items-top-city{color:#fff; font-size:28px;font-weight:500; font-family:PingFangSC-Medium,PingFang SC  }
	.train-items-top-time{color:#fff; font-size:15px;font-weight:500; font-family:PingFangSC-Medium,PingFang SC  }
	.train-sing-up-btn{width: 48px;height: 26px;color:#fff;font-size:12px;font-weight:500;font-family:'PingFangSC-Medium,PingFang SC';
		border: 1px solid #fff;border-radius: 26px;text-align: center;line-height: 26px; }
	.train-items-title{color:#333;font-size:14px;font-weight:400;font-family:'PingFangSC-Medium,PingFang SC';margin: 5px 0; }
	.train-items-time,.train-items-address{color:#595757;font-size:12px;font-weight:400;font-family:'PingFangSC-Medium,PingFang SC'; }
	.train-items-address{margin-right: 10px;}


	.box {
		background: #F8F8F8;
		margin-bottom: 50px;
		overflow: hidden;
	}



</style>

<script>
	import Vue from 'vue';
	import TabBar from '@/components/TabBar.vue';
	import LoginDialog from '@/components/LoginDialog.vue';
	import { NoticeBar,Collapse,CollapseItem,Empty } from 'vant';

	import NewsItem2 from "@/components/news/NewsItem2.vue";
	import NewsItem3 from "@/components/news/NewsItem3.vue";
	import NewsItem1 from "@/components/news/NewsItem1.vue";
	import NewsItem4 from "@/components/news/NewsItem4.vue";

	Vue.use(NoticeBar);
	Vue.use(CollapseItem);
	Vue.use(Collapse);
	Vue.use(Empty);

	export default {
		name: 'HuiyiIndex',
		components: {
			TabBar,LoginDialog,
			NewsItem2,
			NewsItem3,
			NewsItem1,
			NewsItem4
			 
		},
		data: function () {
			return {
				currentIndex:0,
				huiyiAcitiveCs:[],
				loginShow:false,
				showTabBar:false,
				 row:{
					 group_list:[],
					 news_list:[  ],
				 	doing:[],
					 going:[],
					 pass:[]
				 },
				catelist:[]

			}
		},
		filter: {},
		computed:{
			huiyiList(){
				let that = this;
				return this.row.doing.filter((item) =>{
					return item.gametype==  that.currentIndex
				});
			},
			news_list(){
				let that = this;
				if(that.currentIndex<10){
					return [];
				}
				return this.row.news_list['i'+that.currentIndex];
			},
		},
		mounted() {
			document.title = '培训计划';
			 this.showTabBar = window.isApp()? false:true;
			let that = this; 

			 this.fetch()
		},
		destroyed() {
		},
		methods: {
			setCurrent(index){
				this.currentIndex = this.currentIndex==index? 0: index;
			},
			fetch(){
				let that = this;
				this.$api.get('/api/huiyi/planData', {}, (res) => {
					console.log(res)
					that.row = res.data
				},(res) =>{
					
					console.log('没有登录');
					if (res.code == 401 || res.code==402) {
						if(window.isApp()){
							rbLink({
								name:'login','query':{ }
							},'replace');
							return false;
						}
						that.loginShow = true
					}else {
						Toast(res.msg)
					}
				})
			},

			loginSuccess(res){
				console.log('-------登录成功--------',res);
				this.loginShow = false;
				this.fetch();
			},

			loginCancel(){
				console.log('-------取消登录--------');
				// this.loginShow = false;
			},
			file(row){
					rbLink({name:'HuiyiFilesList',query:{station_id:row.id}})
			}


		}
	}
</script>



// WEBPACK FOOTER //
// HuiyiPlan.vue?2a96a5a9